import React, { useEffect } from "react";

import { useState,useMemo } from "react";
import { useRef } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Pagination,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { checkNumber } from "../utilities/FormValidation";
import { grey } from "@mui/material/colors";
import FormPageHeader from "../utilities/FormPageHeader";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import CustomDatePicker from "../utilities/CustomDatePicker";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import CustomTooltip from "./customTooltip";
import jwtDecode from "jwt-decode";
import Decline from "./Decline";
import SDRDiscount from "./SDRDiscount";
import PSDDiscount from "./PSDDiscount";
import SDPDiscount from "./SDPDiscount";
import moment from "moment";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getPendingApprovals } from "app/theme-layouts/shared-components/notificationPanel/store/dataSlice";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .total-list": {
      padding: "0px 5px",
      justifyContent: "space-between",

      "& li": {
        padding: "5px",
        fontSize: "12px",
        width: "100%",

        "& label": {
          fontSize: "12px",
          color: "#fff !important",
          paddingBottom: "2px",
          display: "block",
        },
      },
    },
  },
}));
const COLORS = {
  pending: "#FF8503",
  approved: "#114635",
};
export default function SpecialDiscount(props) {
  const token =
    localStorage &&
    localStorage.getItem("token") &&
    jwtDecode(localStorage.getItem("token"));
  const classes = useStyles(props);
  const theme = useTheme();
  const dispatch = useDispatch();
  const sdrChildRef = useRef(null);
  const sdpChildRef = useRef(null);
  const psdChildRef = useRef();
  const [rowData, setRowData] = useState([]);
  // const [territory, setTerritory] = useState();
  const gridRef = useRef();
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const perPage = 20;
  const [gridApi, setGridApi] = useState(null);
  const [wg1SDR, setWg1SDR] = useState("");
  const [wg2SDR, setWg2SDR] = useState("");
  const [wg1SDP, setWg1SDP] = useState("");
  const [wg2SDP, setWg2SDP] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsID, setSelectedRowsID] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [validError, setValidError] = useState({});
  const [checkSubmit, setCheckSubmit] = useState(false);
  const [customerOptions, setCustomerOptions] = useState();
  const [vendorOptions, setVendorOptions] = useState();
  const [orderCategoryOptions, setOrderCategoryOptions] = useState();
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [territoryOptions, setTerritoryOptions] = useState();
  const [SDPData, setSDPData] = useState();
  const [SDRData, setSDRData] = useState();
  const [PSDData, setPSDData] = useState();
  const [discountCount, setDiscountCount] = useState(0);
  const [tabValue, setTabValue] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [project, setProject] = useState("");
  const [searchFlag, setSearchFlag] = useState(false);
  const [showInactive, setShowInactive] = useState(false);

  const initialFilter = {
    customerNum: "",
    territory: "",
    vendorNum: "",
    orderCategory: "",
    project: "",
    fromDate: null,
    toDate: null,
    specialDiscStatus: token?.scope?.includes("ROLE_MD")
      ? "PENDING"
      : "WAITING",
    specialDiscType: tabValue === 0 ? "SDR" : "SDP",
    page: 0,
    size: 25,
    direction: "DESC",
    sortBy: "createdDate",
  };

  const [filter, setFilter] = useState(initialFilter);
  const [filterPagination, setFilterPagination] = useState(initialFilter);

  const [statusFilter, setStatusFilter] = useState(filter.specialDiscStatus);
  const [territory, setTerritory] = useState(filter.territory);
  const [customerFilter, setCustomerFilter] = useState(filter.customerNum);
  const [vendorFilter, setVendorFilter] = useState(filter.vendorNum);
  const [orderCategoryFilter, setOrderCategoryFilter] = useState(
    filter.orderCategory,
  );
  const [statusOptions, setStatusOptions] = useState([
    { value: "All", label: "All" },
    { value: "WAITING", label: "WAITING" },
    { value: "PENDING", label: "PENDING" },
    { value: "APPROVED", label: "APPROVED" },
    { value: "REJECTED", label: "REJECTED" },
    { value: "DECLINED", label: "DECLINED" },
  ]);

  const [searchParams, setSearchParams] = useSearchParams();

  const discountUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}`;
  const rolesOnly =
    token?.scope?.filter((item) => item.startsWith("ROLE_")) || [];
  const isOnlyRoleIAM = rolesOnly.length === 1 && rolesOnly[0] === "ROLE_IAM";
  const clearSDRValue = () => {
    setWg1SDR("");
    setWg2SDR("");
  };

  const clearSDPValue = () => {
    setWg1SDP("");
    setWg2SDP("");
  };
  const handleFilterChange = (key, value) => {
    updateURL(key, value);
    setFilter((prev) => ({ ...prev, [key]: value || null, page: 0 }));
    setFilterPagination((prev) => ({ ...prev, [key]: value || null, page: 0 }));
    setCurrentPage(1);

    switch (key) {
      case "specialDiscStatus":
        setStatusFilter(value);
        break;
      case "territory":
        setTerritory(value);
        setCustomerFilter("");
        setFilter((prev) => ({ ...prev, customerNum: null }));
        setFilterPagination((prev) => ({ ...prev, customerNum: null }));
        searchParams.delete("customerNum");
        setSearchParams(searchParams);
        break;
        break;
      case "customerNum":
        setCustomerFilter(value);
        break;
      case "vendorNum":
        setVendorFilter(value);
        break;
      case "orderCategory":
        setOrderCategoryFilter(value);
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    const getCustomerOptionsByTerritory = async () => {
      if (!territory) {
        try {
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
          const partners = await OAuthService.getList(
            url +
              `/search/findByCustomerType?customerType=REGULAR`,
          );
          const result = partners?.data?._embedded?.companies.map((value) => {
            return {
              label: `${value?.id}-${value?.shortKey}-${value?.countryName}`,
              name: value.name,
              id: value.id,
              active:value.active,
            };
          });
          setCustomerOptions(result);
        } catch (error) {
          toast.error(error.message);
        }
        return;
      } else {
        try {
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryIn?territories=${territory}`;
          const list = await OAuthService.getList(url);

          let companies = list.data?._embedded?.companies;
          companies = companies.map((company) => {
            return {
              id: company.id,
              label: `${company?.id}-${company?.shortKey}-${company?.countryName}`,
              name: company.name,
              active:company.active
            };
          });
          setCustomerOptions(companies);
        } catch (error) {
          toast.error(error.message || "Failed to fetch customer options");
        }
      }
    };

    getCustomerOptionsByTerritory();
  }, [territory]);
  const handleClear = () => {
    setFilter(initialFilter);
    setFilterPagination(initialFilter);

    setTerritory(initialFilter.territory);
    setCustomerFilter(initialFilter.customerNum);
    setVendorFilter(initialFilter.vendorNum);
    setOrderCategoryFilter(initialFilter.orderCategory);
    setProject("");
    setSearchFlag(false);
    setShowInactive(false);

    const emptyParams = new URLSearchParams();
    setSearchParams(emptyParams);
  };
  const handleTabChange = (event, value) => {
    setTabValue(value);
    updateURL("tab", value);
    const tabName = value === 0 ? "SDR" : "SDP";
    handleFilterChange("specialDiscType", tabName);
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setFilterPagination((prev) => ({ ...prev, page: newPage - 1 }));
  };

  const handleSearchClick = () => {
    handleFilterChange("project", project);
    setSearchFlag(true);
  };

  const handleClearClick = () => {
    setProject("");
    handleFilterChange("project", "");
    setSearchFlag(false);
  };

  const handleDateChange = (date, key) => {
    handleFilterChange(key, date);
  };
  const updateURL = (key, value) => {
    if (value === "" || value === null) {
      searchParams.delete(key);
    } else {
      searchParams.set(key, value);
    }
    setSearchParams(searchParams);
  };

  const handleSelectionChanged = (selectedRows, selectedId) => {
    setSelectedRows(selectedRows);
    setSelectedRowsID(selectedId);
  };
const visibleCustomerOptions = useMemo(() => {
  if (!customerOptions) return customerOptions;
  return showInactive
    ? customerOptions
    : customerOptions.filter((opt) => opt.active);
}, [customerOptions, showInactive]);
  const StatCard = ({ label, value, bg }) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.5,
        px: 3,
        py: 2,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
        minWidth: 110,
      }}
    >
      <Typography
        sx={{ fontSize: 26, fontWeight: 800, color: bg, lineHeight: 1 }}
      >
        {value ?? 0}
      </Typography>
      <Typography
        variant="caption"
        sx={{ fontWeight: 600, color: theme.palette.text.secondary }}
      >
        {label}
      </Typography>
    </Box>
  );

  const headerInputFields = () => {
    return (
      <>
        {token?.scope?.includes("ROLE_MD") && (
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <StatCard
              label="Pending"
              value={
                tabValue === 0
                  ? SDRData?.PENDING
                  : tabValue === 1
                  ? SDPData?.PENDING
                  : undefined
              }
              bg={COLORS.pending}
            />
            <StatCard
              label="Approved"
              value={
                tabValue === 0
                  ? SDRData?.APPROVED
                  : tabValue === 1
                  ? SDPData?.APPROVED
                  : undefined
              }
              bg={COLORS.approved}
            />
          </Box>
        )}
      </>
    );
  };

  useEffect(() => {
    const restoredFilter = { ...initialFilter };

    restoredFilter.territory = searchParams.get("territory") || "";
    restoredFilter.customerNum = Number(searchParams.get("customerNum")) || "";
    restoredFilter.vendorNum = Number(searchParams.get("vendorNum")) || "";
    restoredFilter.orderCategory = searchParams.get("orderCategory") || "";
    restoredFilter.project = searchParams.get("project") || "";
    restoredFilter.specialDiscStatus =
      searchParams.get("specialDiscStatus") || initialFilter.specialDiscStatus;
    restoredFilter.specialDiscType =
      searchParams.get("specialDiscType") || initialFilter.specialDiscType;

    const tabFromURL = searchParams.get("tab");
    if (tabFromURL !== null) {
      setTabValue(Number(tabFromURL));
    }

    if (searchParams.get("fromDate"))
      restoredFilter.fromDate = new Date(searchParams.get("fromDate"));

    if (searchParams.get("toDate"))
      restoredFilter.toDate = new Date(searchParams.get("toDate"));

    setFilter(restoredFilter);
    setFilterPagination(restoredFilter);
    // Set UI fields:
    setTerritory(restoredFilter.territory);
    setCustomerFilter(restoredFilter.customerNum);

    setVendorFilter(restoredFilter.vendorNum);
    setOrderCategoryFilter(restoredFilter.orderCategory);
    setProject(restoredFilter.project);
    setStatusFilter(restoredFilter.specialDiscStatus);
  }, []);
  const urlSyncMounted = useRef(false);
  useEffect(() => {
    if (!urlSyncMounted.current) {
      urlSyncMounted.current = true;
      return;
    }

    const tabParam = searchParams.get("tab");
    const statusParam = searchParams.get("specialDiscStatus");
    const next = {};

    if (tabParam === "0" || tabParam === "1") {
      const urlTab = Number(tabParam);
      const urlType = urlTab === 0 ? "SDR" : "SDP";
      if (urlTab !== tabValue) setTabValue(urlTab);
      if (urlType !== filterPagination.specialDiscType) {
        next.specialDiscType = urlType;
      }
    }

    if (statusParam && statusParam !== filterPagination.specialDiscStatus) {
      next.specialDiscStatus = statusParam;
    }

    if (Object.keys(next).length > 0) {
      setFilter((prev) => ({ ...prev, ...next, page: 0 }));
      setFilterPagination((prev) => ({ ...prev, ...next, page: 0 }));
      setCurrentPage(1);
      if (next.specialDiscStatus) setStatusFilter(next.specialDiscStatus);
    }
  }, [searchParams]);
  useEffect(() => {
    if (customerFilter && customerOptions.length > 0) {
      setCustomerFilter(customerFilter);
    }
  }, [customerOptions]);

  const handleSuccessMsg = (msg) => {
    if (msg) {
      setSuccessMsg(msg);
      setSnackState(true);
    } else {
      setSnackState(false);
    }
  };

  useEffect(() => {
    if (
      token?.scope?.includes("ROLE_IAM") &&
      !(
        token?.scope?.includes("ROLE_ADMIN") ||
        token?.scope?.includes("ROLE_SOPDIR")
      ) &&
      territoryOptions
    ) {
      setTerritory(territoryOptions[0]?.id || "");
    }
  }, [territoryOptions]);

  useEffect(() => {
    if (selectedRows?.length > 0) {
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
    }
  }, [selectedRows]);

  useEffect(() => {
    handleSuccessMsg();
  }, []);
  useEffect(() => {
    if (vendorFilter && vendorOptions.length > 0) {
      const match = vendorOptions.find((o) => o.id === vendorFilter);
      if (match) {
        setVendorFilter(vendorFilter);
      }
    }
  }, [vendorOptions]);
  useEffect(() => {
    if (customerFilter && customerOptions.length > 0) {
      const match = customerOptions.find((o) => o.id === customerFilter);

      if (match) {
        setCustomerFilter(customerFilter); // triggers re-render
      }
    }
  }, [customerOptions]);

  useEffect(() => {
    const territories = async () => {
      if (
        token.scope.includes("ROLE_IAM") &&
        !(
          token?.scope?.includes("ROLE_ADMIN") ||
          token?.scope?.includes("ROLE_SOPDIR")
        )
      ) {
        const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${token.email}`;
        const areaManager = await OAuthService.getList(findAllByAreaManagerUrl);
        const territoryList =
          areaManager?.data?._embedded?.territories.map((value) => ({
            label: value?.displayName,
            value: value?.displayName,
            id: value?.id,
          })) || [];
        setTerritoryOptions(territoryList);
      } else {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territory}?size=100`;
        const territories = await OAuthService.getList(url);

        const result = territories?.data?._embedded.territories.map((value) => {
          return {
            label: value.displayName,
            value: value.displayName,
            id: value?._links?.territory?.href.split("/").pop(),
          };
        });
        setTerritoryOptions(result);
      }
    };
    territories();

    const factoryVendor = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByActive?active=true`;
      const factoryVendor = await OAuthService.getList(url);
      const result = factoryVendor?.data?._embedded?.factoryVendors.map(
        (value) => {
          return { label: value.shortKey, value: value.shortKey, id: value.id };
        },
      );
      setVendorOptions(result);
    };
    factoryVendor();
    const orderType = async () => {
      const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}/search/findByAllowOrder?allowOrder=true`;
      const orderCategories = await OAuthService.getList(url);

      const result = orderCategories?.data?._embedded?.orderCategories.map(
        (value) => {
          return { label: value.name, value: value.name };
        },
      );
      setOrderCategoryOptions(result);
    };
    orderType();

    const partnerFilter = async () => {
      if (
        token?.scope.includes("ROLE_IAM") &&
        !(
          token?.scope?.includes("ROLE_ADMIN") ||
          token?.scope?.includes("ROLE_SOPDIR")
        )
      ) {
        try {
          const findAllByAreaManagerUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.territoryList}/search/findAllByAreaManagerContains?email=${token.email}`;
          const areaManager = await OAuthService.getList(
            findAllByAreaManagerUrl,
          );
          const areaManagerIds =
            areaManager?.data?._embedded?.territories?.map((t) => t.id) || [];
          const queryParams = areaManagerIds
            .map((id) => `territories=${id}`)
            .join("&");

          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/search/findByTerritoryIn?${queryParams}`;
          const partners = await OAuthService.getList(url);

          const result = partners?.data?._embedded?.companies.map((value) => {
            return {
              label: `${value?.id}-${value?.shortKey}-${value?.countryName}`,
              name: value.name,
              id: value.id,
              active:value.active
            };
          });
          setCustomerOptions(result);
        } catch (error) {
          setError(error.message);
        }
      } else {
        try {
          const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}`;
          const partners = await OAuthService.getList(
            url +
              `/search/findByCustomerType?customerType=REGULAR`,
          );
          console.log(partners?.data?._embedded?.companies)
          const result = partners?.data?._embedded?.companies.map((value) => {
            return {
              label: `${value?.id}-${value?.shortKey}-${value?.countryName}`,
              name: value.name,
              id: value.id,
              active:value.active
            };
          });
          setCustomerOptions(result);
        } catch (error) {
          toast.error(error.message);
        }
      }
    };

    partnerFilter();
  }, []);

  const cleanSearchQuery = (query) => {
    for (let key in query) {
      if (
        query[key] === "" ||
        query[key] === null ||
        query[key] === undefined
      ) {
        delete query[key];
      }
    }
    return query;
  };
  const SDRCount = async () => {
    try {
      if (token?.scope?.includes("ROLE_MD")) {
        let searchQuery = filterPagination;
        searchQuery = { ...searchQuery, specialDiscStatus: "PENDING" };

        const updatedSearchQuery = cleanSearchQuery(searchQuery);

        const url = await OAuthService.addData(
          discountUrl + "api/discountStatusCount/SDR",
          updatedSearchQuery,
        );
        setSDRData(url?.data);
        dispatch(getPendingApprovals());
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const SDPCount = async () => {
    try {
      if (token?.scope?.includes("ROLE_MD")) {
        let searchQuery = filterPagination;
        searchQuery = { ...searchQuery, specialDiscStatus: "PENDING" };

        const updatedSearchQuery = cleanSearchQuery(searchQuery);

        const url = await OAuthService.addData(
          discountUrl + "api/discountStatusCount/SDP",
          updatedSearchQuery,
        );
        setSDPData(url?.data);
        dispatch(getPendingApprovals());
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };
  return (
    <>
      <FormPageHeader
        componentName="Special Discount Management"
        pageName="Special Discount Management"
        currentPage="Special Discount Management"
        orderHeaderAction={headerInputFields()}
        successMsg={successMsg}
        snackState={snackState}
        error={error}
        //  gridRef={tabValue ===0?sdrChildRef:sdpChildRef}
      >
        <Box sx={{ px: 3, pt: 1, pb: 2 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 1.5,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: 700, color: theme.palette.text.primary }}
            >
              Filters
            </Typography>

            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  fontSize: 13,
                }}
              >
                <input
                  type="checkbox"
                  checked={showInactive}
                  onChange={(e) => setShowInactive(e.target.checked)}
                />
                Show Inactive Customers
              </label>

              <Tooltip title="Clear all filters">
                <Button
                  variant="outlined"
                  color="secondary"
                  size="small"
                  startIcon={
                    <FuseSvgIcon size={16}>
                      material-solid:clear_all
                    </FuseSvgIcon>
                  }
                  onClick={handleClear}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr 1fr",
                sm: "repeat(3, 1fr)",
                md: "repeat(4, 1fr)",
                lg: "repeat(8, 1fr)",
              },
              gap: 1.5,
            }}
          >
            <Select
              required
              placeholder="Territory"
              options={territoryOptions}
              value={territoryOptions?.filter((obj) => obj.id === territory)}
              onChange={(e, action) =>
                handleFilterChange(
                  "territory",
                  action.action === "clear" ? "" : e.id,
                )
              }
              styles={customStyles()}
              isDisabled={territoryOptions?.length === 1 ? true : false}
              isClearable
            />

            <Select
              required
              placeholder="Customer"
              options={visibleCustomerOptions}
              value={visibleCustomerOptions?.filter(
                (obj) => obj.id === customerFilter,
              )}
              onChange={(e, action) =>
                handleFilterChange(
                  "customerNum",
                  action.action === "clear" ? "" : e.id,
                )
              }
              styles={customStyles()}
              isClearable
            />
            <Select
              required
              placeholder="Vendor"
              options={vendorOptions}
              value={vendorOptions?.filter((obj) => obj.id === vendorFilter)}
              onChange={(e, action) =>
                handleFilterChange(
                  "vendorNum",
                  action.action === "clear" ? "" : e.id,
                )
              }
              styles={customStyles()}
              isClearable
            />
            <Select
              required
              placeholder="Order Category"
              options={orderCategoryOptions}
              value={orderCategoryOptions?.filter(
                (obj) => obj.value === orderCategoryFilter,
              )}
              onChange={(e, action) =>
                handleFilterChange(
                  "orderCategory",
                  action.action === "clear" ? "" : e.value,
                )
              }
              styles={customStyles()}
              isClearable
            />
            <TextField
              type="text"
              label="Order Reference"
              variant="outlined"
              placeholder="Order Reference"
              fullWidth
              name="project"
              value={project}
              onChange={(e) => setProject(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Backspace" && project.length <= 1) {
                  handleClearClick();
                }
              }}
              InputProps={{
                endAdornment: !searchFlag ? (
                  <InputAdornment position="end">
                    <IconButton onClick={handleSearchClick}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ) : (
                  <InputAdornment position="end">
                    <IconButton onClick={handleClearClick}>
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <CustomDatePicker
              label="From"
              className="w-full"
              format={"dd-MM-yyyy"}
              name={"fromDate"}
              value={filter?.fromDate}
              maxDate={filter.toDate && new Date(filter.toDate)}
              handleChange={(e) => handleDateChange(e, "fromDate")}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
            <CustomDatePicker
              label="To"
              className="w-full"
              format={"dd-MM-yyyy"}
              name={"toDate"}
              value={filter.toDate}
              minDate={filter.fromDate && new Date(filter.fromDate)}
              handleChange={(e) => handleDateChange(e, "toDate")}
              componentsProps={{
                actionBar: { actions: ["clear"] },
              }}
            />
            <Select
              required
              placeholder="Status"
              options={statusOptions}
              value={
                statusOptions?.find(
                  (option) => option.value === filter.specialDiscStatus,
                ) || null
              }
              onChange={(e, action) =>
                handleFilterChange(
                  "specialDiscStatus",
                  action.action === "clear" ? "" : e.value,
                )
              }
              styles={customStyles()}
            />
          </Box>
        </Box>
      </FormPageHeader>
      <div className={clsx(classes.root + " h-[30px]", "")}>
        {isOnlyRoleIAM ? (
          <>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="secondary"
              textColor="inherit"
              sx={{
                "& .MuiButtonBase-root": { bottom: "12px" },
                "& .MuiTabs-indicator": { bottom: "18px" },
              }}
              variant="scrollable"
              scrollButtons="auto"
              classes={{ root: "w-full border-b-1" }}
            >
              <Tab
                label="SDR"
                sx={{
                  color: "text.secondary",
                  "&.Mui-selected": { color: "text.primary" },
                }}
              />
            </Tabs>
          </>
        ) : (
          <>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              indicatorColor="secondary"
              textColor="inherit"
              sx={{
                "& .MuiButtonBase-root": { bottom: "12px" },
                "& .MuiTabs-indicator": { bottom: "18px" },
              }}
              variant="scrollable"
              scrollButtons="auto"
              classes={{ root: "w-full border-b-1" }}
            >
              <Tab
                label="SDR"
                sx={{
                  color: "text.secondary",
                  "&.Mui-selected": { color: "text.primary" },
                }}
              />
              <Tab
                label="SDP"
                sx={{
                  color: "text.secondary",
                  "&.Mui-selected": { color: "text.primary" },
                }}
              />
            </Tabs>
          </>
        )}
      </div>
      <div className={clsx(classes.root, tabValue !== 0 ? "hidden" : "h-full")}>
        <SDRDiscount
          showAlert={showAlert}
          ref={sdrChildRef}
          onSelectionChanged={handleSelectionChanged}
          territory={territory}
          customerFilter={customerFilter}
          fromDate={fromDate}
          toDate={toDate}
          vendorFilter={vendorFilter}
          statusFilter={statusFilter}
          wg2SDR={wg2SDR}
          wg1SDR={wg1SDR}
          successMsg={handleSuccessMsg}
          clearSDRValue={clearSDRValue}
          SDRCount={SDRCount}
          tabValue={tabValue}
          discountCount={discountCount}
          setDiscountCount={setDiscountCount}
          filter={filter}
          filterPagination={filterPagination}
        />
      </div>
      <div className={clsx(classes.root, tabValue !== 1 ? "hidden" : "h-full")}>
        <SDPDiscount
          showAlert={showAlert}
          ref={sdpChildRef}
          onSelectionChanged={handleSelectionChanged}
          territory={territory}
          customerFilter={customerFilter}
          fromDate={fromDate}
          toDate={toDate}
          wg2SDP={wg2SDP}
          wg1SDP={wg1SDP}
          successMsg={handleSuccessMsg}
          clearSDPValue={clearSDPValue}
          SDPCount={SDPCount}
          discountCount={discountCount}
          setDiscountCount={setDiscountCount}
          tabValue={tabValue}
          filter={filter}
          filterPagination={filterPagination}
        />
      </div>
      {discountCount > 1 && (
        <Pagination
          variant="outlined"
          count={discountCount}
          page={currentPage}
          onChange={handlePageChange}
          className="flex justify-center"
        />
      )}
    </>
  );
}
